import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Box,
    Tooltip
} from '@mui/material';
import { useMaterialReactTable } from 'material-react-table';
import {
    AddBox as AddBoxIcon,
} from '@mui/icons-material';
import miniatura_pdf from '../../../../../assets/imgs/miniatura_pdf.png';
import VerifiedIcon from '@mui/icons-material/Verified'; // ícone sugestão (pode trocar)
import office from '../../../../../assets/imgs/office.png';

import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import Skeleton from '@material-ui/lab/Skeleton';
import CancelIcon from '@mui/icons-material/Cancel';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import EditNoteIcon from '@mui/icons-material/EditNote';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import TaskIcon from '@mui/icons-material/Task';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { useTheme } from "@mui/material/styles";
import MenuIcon from '@mui/icons-material/Menu';
import {
    Card,
    Divider
} from "@mui/material";
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import moment from 'moment'; // Importe a biblioteca Moment.js
import { Drawer, List, ListItem, ListItemText, ListItemIcon, useMediaQuery } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaidIcon from '@mui/icons-material/Paid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import api from '../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import LinkIcon from '@mui/icons-material/Link';

import Rodape from '../../../../../components/Rodape';
import {
    MaterialReactTable,

} from 'material-react-table';
import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CircularProgress, DialogActions, DialogContentText } from '@mui/material';

import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Snackbar, Alert, Backdrop } from '@mui/material';

const drawerWidth = 240;



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));



export default function OrdemComprasComponent({ idColaborador, idProposta, idFornecedor }) {



    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // mobile até sm
    const [open, setOpen] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const regra = Cookies.get("regra") || "";


    const [autorizadasChecked, setAutorizadasChecked] = useState(() => {
        if (regra.includes("ADMIN_OC_AUTORIZADAS")) {
            return true; // força sempre true
        }

        const cookie = Cookies.get("filtro_ordem_compra_autorizadas");
        return cookie ? cookie === "true" : false; // se não existir, false
    });

    const [filtroChecked, setFiltroChecked] = useState(() => {
        if (regra.includes("ADMIN_OC_MINHAS_OCS")) {
            return true; // força sempre true
        }

        const cookie = Cookies.get("filtro_ordem_compra");
        return cookie ? cookie === "true" : true; // se não existir, true
    });

    const [aguardandoChecked, setAguardandoChecked] = useState(() => {
        const cookie = Cookies.get("filtro_ordem_compra_aguardando");
        return cookie ? cookie === "true" : false; // se não existir, false
    });

    const [abertasChecked, setAbertasChecked] = useState(() => {
        const cookie = Cookies.get("filtro_ordem_compra_abertas");
        return cookie ? cookie === "true" : true; // se não existir, true
    });

    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [height, setHeight] = useState(0);

    const [tableHeight, setTableHeight] = useState(400); // valor inicial qualquer

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 300); // altura da tela menos 200px
        };

        updateHeight(); // calcula ao montar o componente
        window.addEventListener('resize', updateHeight); // recalcula ao redimensionar

        return () => window.removeEventListener('resize', updateHeight);
    }, []);


    const [value, setValue] = useState(1);
    const [objetos, setObjetos] = useState(null);


    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 100,
    });

    const [totalRegistros, setTotalRegistros] = useState(0);
    const [filtro, setFiltro] = useState("");


    function checkDimenssoes() {

        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


        setHeight(altura * 0.75);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });


    const [numOrdensAbertas, setNumOrdensAbertas] = useState(0);
    const [numOrdensAguardando, setNumOrdensAguardando] = useState(0);
    const [numOrdensSolicitante, setNumOrdensSolicitante] = useState(0);
    const [numOrdensAutorizador, setNumOrdensAutorizador] = useState(0);

    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            await api.get(`v1/protected/ordensdecompras/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}&idcolaborador=${idColaborador}&idproposta=${idProposta}&idfornecedor=${idFornecedor}`, {
                headers: headers
            }).then(function (response) {
                console.log("aqui 0");

                // === INÍCIO DA LÓGICA DE CONTAGEM ===
                let contAbertas = 0;
                let contAguardando = 0;
                let contSolicitante = 0;
                let contAutorizador = 0;

                response.data.dados.forEach((ordem_compra) => {
                    const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);
                    const status = parseInt(ordem_compra.status, 10);

                    if (ordem_compra.solicitantes?.some(s => parseInt(s.id_usuario, 10) === id_usuario_logado)) contSolicitante++;
                    if (ordem_compra.autorizacoes?.some(a => parseInt(a.id_usuario, 10) === id_usuario_logado)) contAutorizador++;
                    if (status <= 1) contAbertas++;
                    if (status === 2) contAguardando++;
                });

                setNumOrdensAbertas(contAbertas);
                setNumOrdensAguardando(contAguardando);
                setNumOrdensSolicitante(contSolicitante);
                setNumOrdensAutorizador(contAutorizador);
                // === FIM DA LÓGICA DE CONTAGEM ===


                setObjetos(response.data.dados);
                setTotalRegistros(response.data.total);

                setLoading(false);
                console.log("aqui 5");


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }

    useEffect(() => {

        checkDimenssoes();
        // listar();
    }, []);




    function handleFiltroChecked(v) {
        setFiltroChecked(v);
        Cookies.set("filtro_ordem_compra", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }




    // Se quiser garantir que o estado sempre sincronize quando carregar
    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra");
        if (savedFiltro !== undefined) {
            setFiltroChecked(savedFiltro === "true");
        }
    }, []);





    function handleAutorizadasChecked(v) {
        setAutorizadasChecked(v);
        Cookies.set("filtro_ordem_compra_autorizadas", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_autorizadas");
        if (savedFiltro !== undefined) {
            setAutorizadasChecked(savedFiltro === "true");
        }
    }, []);





    function handleAbertasChecked(v) {
        setAbertasChecked(v);
        Cookies.set("filtro_ordem_compra_abertas", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_abertas");
        if (savedFiltro !== undefined) {
            setAbertasChecked(savedFiltro === "true");
        }
    }, []);





    function handleAguardandoChecked(v) {
        setAguardandoChecked(v);
        Cookies.set("filtro_ordem_compra_aguardando", v.toString(), { expires: 120 });
        // expires: 30 -> cookie dura 30 dias
    }

    useEffect(() => {
        const savedFiltro = Cookies.get("filtro_ordem_compra_aguardando");
        if (savedFiltro !== undefined) {
            setAguardandoChecked(savedFiltro === "true");
        }
    }, []);




    useEffect(() => {

        listar();


    }, [filtroChecked, autorizadasChecked, aguardandoChecked, abertasChecked, pagination.size, pagination.index]);

    function novo() {
        window.location.href = "/gestao/administracao/ordensdecompras/cadastrarordemcompra"

    }





    const handleClickEdicao = (row) => {


        window.location.href = "/gestao/administracao/ordensdecompras/editar/" + row.id_ordem_compra;


    };



    function formatDate(date) {
        // Formate a data para 'HH:mm DD/MMM/YYYY'
        return moment(date).format('HH:mm DD/MM/YYYY');
    }







    const handleMenuClick = (newValue) => {
        if (newValue === 0) {

        } else if (newValue === 1) {

            listar();
        } else if (newValue === 2) {


        }
        setValue(newValue);
    };



    const [idOrdemCompraAutorizar, setIdOrdemCompraAutorizar] = useState(0);

    const [openBack, setOpenBack] = useState(false)
    async function handleClickReforcarAutorizacao(idOrdemCompraAutorizar) {
        try {
            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            // Chamada ao endpoint
            const response = await api.get(
                `/v1/protected/ordensdecompras/ordemdecompra/reforcarautorizacao/${idOrdemCompraAutorizar}`,
                { headers: headers }
            );

            const retorno = response.data; // será "Fora de Status" ou "Enviado"

            // Tratar resposta
            if (retorno === "Enviado") {
                // Mensagem de sucesso
                alert("Notificações enviadas para os autorizantes pendentes!");
                // Aqui você pode atualizar a tabela ou interface, se necessário
                // ex: atualizarStatusTabela(idOrdemCompraAutorizar);
            } else if (retorno === "Fora de Status") {
                // Mensagem de alerta
                alert("A ordem de compra não está no status correto para reforçar autorização.");
            } else {
                // Qualquer outro retorno inesperado
                console.warn("Retorno inesperado do servidor:", retorno);
            }

        } catch (err) {
            console.error("Erro ao reforçar autorização:", err);
            alert("Ocorreu um erro ao tentar reforçar a autorização. Verifique o console.");
        }
    }

    const handleOpenAutorizar = (id) => {
        console.log("open autorizar chamado!");
        setIdOrdemCompraAutorizar(id);
        setOpenAutorizar(true);
    }

    const [openAutorizar, setOpenAutorizar] = useState(false)
    const [codigoValidacao, setCodigoValidacao] = useState("");
    const [open2, setOpen2] = useState(false);

    function handleCloseOpenAutorizar() {
        setIdOrdemCompraAutorizar(0);
        setOpenAutorizar(false);

    }


    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");



    async function autorizar() {
        try {
            const id_usuario = Cookies.get('id_usuario');

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const valido = true; // aqui você valida o código se quiser

            if (valido) {
                const response = await api.put(
                    `/v1/protected/ordensdecompras/ordemdecompra/autorizar/${idOrdemCompraAutorizar}/${id_usuario}`,
                    { headers: headers }
                );

                const cadastro_salvo = response.data;

                if (cadastro_salvo) {
                    // FECHA DIALOG E BACKDROP
                    setOpenAutorizar(false);
                    setOpenBack(false);

                    // MOSTRA TOAST
                    setToastMessage("Autorização Concluída");
                    setToastOpen(true);

                    // ATUALIZA LISTAGEM
                    listar();
                } else {
                    setOpenBack(false);
                    setToastMessage("Erro de Conexão, tente novamente mais tarde");
                    setToastOpen(true);
                }
            } else {
                setOpen2(false);
                setToastMessage("Código Inválido!");
                setToastOpen(true);
            }
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            setOpen2(false);
            setToastMessage("Erro de Conexão, tente novamente mais tarde");
            setToastOpen(true);
        }
    }


    const gerarEntradaEstoque = (id) => {
        window.open(
            "/gestao/operacional/almoxarifado/entradaestoque/cadastrarentradaestoque?id-pre-cotacao=" + id,
            "_blank"
        );
    };


    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_ordem_compra',
                header: 'ID',
                size: 50,
            },
            {
                accessorFn: (row) => row.nivel_prioridade,
                id: 'nivel_prioridade',
                header: '🔺',
                size: 50,
                Cell: ({ renderedCellValue }) => {
                    let icon = null;
                    let title = '';

                    switch (renderedCellValue) {
                        case 0:
                            icon = <LowPriorityIcon sx={{ color: 'gray' }} />;
                            title = 'Prioridade: Comum';
                            break;
                        case 1:
                            icon = <WarningIcon sx={{ color: 'orange' }} />;
                            title = 'Prioridade: Urgente';
                            break;
                        case 2:
                            icon = <PriorityHighIcon sx={{ color: 'red' }} />;
                            title = 'Prioridade: Priorizar';
                            break;
                        default:
                            icon = null;
                            title = 'Prioridade não definida';
                    }

                    return <Tooltip title={title}>{icon}</Tooltip>;
                },
            },
            {
                accessorFn: (row) => row.tipo_ordem,
                id: 'tipo_ordem',
                header: '📄',
                size: 50,
                Cell: ({ renderedCellValue }) => {
                    let icon = null;
                    let title = '';

                    switch (renderedCellValue) {
                        case 0:
                            icon = <ShoppingCartIcon sx={{ color: 'blue' }} />;
                            title = 'Ordem de Compra';
                            break;
                        case 1:
                            icon = <PaidIcon sx={{ color: 'green' }} />;
                            title = 'Solicitação de Pagamento';
                            break;
                        default:
                            icon = <HelpOutlineIcon sx={{ color: 'gray' }} />;
                            title = 'Tipo não definido';
                    }

                    return <Tooltip title={title}>{icon}</Tooltip>;
                },
            },
            {
                accessorFn: (row) => row.status,
                id: 'status',
                header: '📌',
                size: 50,
                Cell: ({ row, renderedCellValue }) => {
                    let icon = null;
                    let title = 'Aguardando Autorização';
                    const isDark = theme.palette.mode === 'dark';

                    switch (renderedCellValue) {
                        case 0:
                            // Editando: branco no dark, preto no light
                            icon = <EditNoteIcon sx={{ color: isDark ? '#ffffff' : '#000000' }} />;
                            title = 'Editando';
                            break;
                        case 1:
                            icon = <HourglassTopIcon sx={{ color: 'orange' }} />;
                            title = 'Aguardando Escolha de Cotação';
                            break;
                        case 2:
                            // Aguardando Autorização: azul
                            icon = <TaskIcon sx={{ color: '#1976d2' }} />
                            title = 'Aguardando Autorização'
                            break;
                        case 3:
                            // Autorizada: verde
                            icon = <AssignmentTurnedInIcon sx={{ color: '#4caf50' }} />;
                            title = 'Autorizado, em Faturamento';
                            break;
                        case 4:
                            // Suprido Via Estoque / Recebimento Concluído: verde
                            icon = <CheckCircleIcon sx={{ color: '#4caf50' }} />;
                            title = 'Recebimento Concluído';
                            break;
                        case 9:
                            // Cancelada: vermelho
                            icon = <CancelIcon sx={{ color: '#f44336' }} />;
                            title = 'Cancelada';
                            break;
                        default:
                            icon = null;
                            title = 'Status não identificado';
                    }

                    // Tooltip
                    const customTooltip = (
                        <div
                            style={{
                                backgroundColor: 'white',
                                height: '30vh',
                                width: '50vw',
                                overflow: 'auto',
                                border: '2px solid black',
                                padding: '8px',
                                color: 'black',
                                fontSize: 14,
                            }}
                        >
                            <h6>Status das Autorizações</h6>
                            {row.original.autorizacoes && row.original.autorizacoes.length > 0 ? (
                                row.original.autorizacoes.map((aut, idx) => (
                                    <div key={idx} style={{ marginBottom: '4px' }}>
                                        • {aut.status}
                                    </div>
                                ))
                            ) : (
                                <div>Nenhuma autorização encontrada</div>
                            )}
                        </div>
                    );

                    // Pegar id do usuário logado
                    const idUsuarioLogado = Cookies.get("id_usuario");

                    const shouldBlink = row.original.autorizacoes?.some(
                        aut => String(aut.id_usuario) === String(idUsuarioLogado) && aut.autorizado === 0
                    );

                    // Criar keyframes dinamicamente só se não existir
                    if (shouldBlink && !document.getElementById('blink-keyframes')) {
                        const styleTag = document.createElement('style');
                        styleTag.id = 'blink-keyframes';
                        styleTag.innerHTML = `
        @keyframes blink {
          0% { background-color: transparent; }
          50% { background-color: yellow; }
          100% { background-color: transparent; }
        }
      `;
                        document.head.appendChild(styleTag);
                    }

                    const innerSpan = (
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                animation: shouldBlink ? "blink 1s infinite" : "none",
                            }}
                        >
                            {icon}
                            {title}
                        </span>
                    );

                    return isMobile ? innerSpan : (
                        <Tooltip title={customTooltip}>
                            {innerSpan}
                        </Tooltip>
                    );
                },
            }

            ,
            {
                accessorFn: (row) => row.usuario?.nome_amigavel || '',
                id: 'usuario',
                header: 'Usuário Criador',
                size: 130,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 130,
            },
            {
                accessorKey: 'valor_total',
                header: 'Valor Total',
                size: 50,
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    return value != null
                        ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                        : '-';
                },
                Footer: ({ table }) => {
                    const total = table
                        .getRowModel()
                        .rows.reduce((sum, row) => {
                            const valor = row.getValue('valor_total');
                            return sum + (valor || 0);
                        }, 0);

                    return (
                        <span
                            style={{
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                                display: 'block',
                                textAlign: 'right',
                                color: '#000',
                            }}
                        >
                            {total.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </span>
                    );
                },
            },
            {
                accessorFn: (row) => row.pre_cotacoes || [],
                id: 'compras',
                header: 'Compras',
                size: 600,
                filterFn: (row, columnId, filterValue) => {
                    if (!filterValue) return true;
                    const termo = filterValue.toLowerCase();
                    const preCotacoes = row.getValue(columnId);
                    return preCotacoes.some(pc =>
                        pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                    );
                },
                Cell: ({ cell, row, table }) => {
                    const preCotacoes = cell.getValue();
                    const filterValue = table.getColumn('compras').getFilterValue() || '';
                    const termo = filterValue.toLowerCase();

                    // 🔹 Filtrar apenas pré-cotações que correspondem ao termo
                    const preCotacoesVisiveis = preCotacoes.filter(pc =>
                        !filterValue || pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                    );

                    const podeMostrarAcoes = row.original.status >= 3;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {preCotacoesVisiveis.map((pc, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '6px 0',
                                        borderBottom: '1px solid #eee',
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        {/* Gerenciar Fornecedor */}
                                        <Tooltip title="Gerenciar Fornecedor" arrow>
                                            <IconButton
                                                component="a"
                                                href={`/gestao/operacional/almoxarifado/fornecedores/gerenciarfornecedor/${pc.id_fornecedor}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                size="small"
                                            >
                                                <SettingsIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>


                                        {podeMostrarAcoes && (
                                            <>
                                                {/* Arquivos */}
                                                {pc.caminho_arquivo_compra && (
                                                    <Tooltip title="Arquivo da Ordem de Compra" arrow>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const link = pc.caminho_arquivo_compra.replaceAll(
                                                                    '/home/wwgrup/ordensdecompra/',
                                                                    'https://gruporosinetos.com/ocmidias/'
                                                                );
                                                                window.open(link, '_blank', 'noopener,noreferrer');
                                                            }}
                                                        >
                                                            {pc.caminho_arquivo_compra.toLowerCase().endsWith('.pdf') ? (
                                                                <img src={miniatura_pdf} alt="pdf" style={{ width: 18, height: 18 }} />
                                                            ) : (
                                                                <img src={office} alt="office" style={{ width: 18, height: 18 }} />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {pc.caminho_arquivo_fornecedor && (
                                                    <Tooltip title="Arquivo Original do Fornecedor" arrow>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                const link = pc.caminho_arquivo_fornecedor.replaceAll(
                                                                    '/home/wwgrup/ordensdecompra/',
                                                                    'https://gruporosinetos.com/ocmidias/'
                                                                );
                                                                window.open(link, '_blank', 'noopener,noreferrer');
                                                            }}
                                                        >
                                                            {pc.caminho_arquivo_fornecedor.toLowerCase().endsWith('.pdf') ? (
                                                                <img src={miniatura_pdf} alt="pdf" style={{ width: 18, height: 18 }} />
                                                            ) : (
                                                                <img src={office} alt="office" style={{ width: 18, height: 18 }} />
                                                            )}
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {/* Entrada de Estoque */}
                                                {pc.id_entrada_estoque > 0 ? (
                                                    <Tooltip title="Gerenciar Entrada de Estoque" arrow>
                                                        <IconButton
                                                            component="a"
                                                            href={`/gestao/operacional/almoxarifado/entradaestoque/gerenciarentradaestoque/${pc.id_entrada_estoque}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            color="primary"
                                                            size="small"
                                                        >
                                                            <SettingsIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Gerar Entrada de Estoque" arrow>
                                                        <IconButton
                                                            color="success"
                                                            size="small"
                                                            onClick={() => gerarEntradaEstoque(pc.id_pre_cotacao)}
                                                        >
                                                            <AddBoxIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        )}

                                        {/* Nome do Fornecedor */}
                                        <span style={{ fontWeight: 500, fontSize: 13, color: '#333' }}>
                                            {pc.nome_fornecedor_amigavel}
                                        </span>
                                    </div>

                                    {/* Valor total */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end',
                                            gap: 4,
                                            fontWeight: 600,
                                            color: '#000',
                                            minWidth: 120,
                                        }}
                                    >
                                        <AttachMoneyIcon sx={{ fontSize: 16, color: '#000' }} />
                                        <span>
                                            {pc.valor_total?.toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL',
                                            }) || '-'}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    );
                },
                Footer: ({ table, column }) => {
                    const filterValue = table.getColumn('compras').getFilterValue() || '';
                    const termo = filterValue.toLowerCase();

                    const total = table.getFilteredRowModel().rows.reduce((acc, row) => {
                        const preCotacoes = row.getValue(column.id);
                        // 🔹 soma apenas pré-cotações visíveis
                        const preCotacoesVisiveis = preCotacoes.filter(pc =>
                            !filterValue || pc.nome_fornecedor_amigavel?.toLowerCase().includes(termo)
                        );
                        const somaLinha = preCotacoesVisiveis.reduce((soma, pc) => soma + (pc.valor_total || 0), 0);
                        return acc + somaLinha;
                    }, 0);

                    return (
                        <div
                            style={{
                                fontWeight: 600,
                                color: '#000',
                                textAlign: 'left',
                                paddingLeft: 8,
                            }}
                        >
                            Total: {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_criacao',
                header: 'Data Criação',
                size: 130,
                filterFn: (row, columnId, filterValue) => {
                    if (!filterValue) return true; // sem filtro
                    const cellValue = row.getValue(columnId);
                    if (!cellValue) return false;

                    // converte para objeto Date
                    const data = new Date(cellValue);
                    if (isNaN(data)) return false;

                    // tenta extrair mês/ano do valor digitado
                    const [mes, ano] = filterValue.split('/').map((v) => parseInt(v, 10));
                    if (!mes || !ano) return false;

                    const mesCell = data.getMonth() + 1;
                    const anoCell = data.getFullYear();

                    // compara apenas mês/ano
                    return mesCell === mes && anoCell === ano;
                },
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },
            {
                accessorFn: (row) =>
                    row.solicitantes?.map((s) => s.nome_amigavel).join(', ') || '',
                id: 'solicitantes',
                header: 'Solicitantes',
                size: 250,
                Cell: ({ cell, row }) => {
                    const solicitantes = cell.getValue();
                    const idOrdemServico = row.original.id_ordem_servico;

                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flexWrap: 'wrap' }}>
                            <span>
                                {solicitantes}
                                {idOrdemServico && idOrdemServico > 0
                                    ? ` através da O.S nº ${idOrdemServico}`
                                    : ''}
                            </span>

                            {idOrdemServico && idOrdemServico > 0 && (
                                <Tooltip title="Abrir Ordem de Serviço" arrow>
                                    <IconButton
                                        component="a"
                                        href={`/gestao/administracao/ordensdeservicos/editar/${idOrdemServico}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                    >
                                        <SettingsIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    );
                },
            },
            {
                accessorFn: (row) => row.pre_cotacoes || [],
                id: 'financeiro',
                header: 'Financeiro',
                size: 350,
                Cell: ({ cell }) => {
                    const preCotacoes = cell.getValue();

                    if (!preCotacoes || preCotacoes.length === 0) return "-";

                    return (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                            {preCotacoes.map((pc, index) => {
                                const lanc = pc.lancamento;
                                const idLancamento = lanc?.id_lancamento;

                                const total = lanc?.valor ?? 0;
                                const pago = lanc?.valor_pago_concluido ?? 0;
                                const restante = (pago - total) ?? 0;

                                if (!idLancamento) {
                                    return (
                                        <span key={index} style={{ color: "red" }}>
                                            Na Compra ID {pc.id_pre_cotacao} não foi gerado lançamento
                                        </span>
                                    );
                                }

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: 8,
                                        }}
                                    >
                                        <span>
                                            #{idLancamento} | Total:{" "}
                                            {total.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Pago: {pago.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} |{" "}
                                            Restante: {restante.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                        </span>

                                        <Tooltip title="Gerenciar Lançamento">
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={() =>
                                                    window.open(
                                                        `/gestao/financas/lancamento/gerenciar/${idLancamento}`,
                                                        "_blank"
                                                    )
                                                }
                                            >
                                                <OpenInNewIcon fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                );
                            })}
                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_hora_maxima_conclusao',
                header: 'Data Máxima Conclusão',
                size: 130,
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },

        ],
        [],
    );


    const backgroundColorPage = 'white';


    const [openAviso, setOpenAviso] = useState(false);

    const handleCopyLink = (id) => {
        const link = `https://gruporosinetos.com/gestao/administracao/ordensdecompras/editar/${id}`;
        navigator.clipboard.writeText(link);
        setOpenAviso(true); // mostra o toast
    };



    const table = useMaterialReactTable({
        columns,
        data: objetos,
        enableBottomToolbar: !isMobile,
        enableGlobalFilterModes: true,
        enablePagination: !isMobile,
        enableRowActions: true,
        paginationDisplayMode: 'pages',
        manualPagination: true,
        rowCount: totalRegistros,
        state: { pagination },
        onPaginationChange: !isMobile ? setPagination : undefined,
        getRowId: (row) => row.id_ordem_compra,
        enableGrouping: true,
        initialState: {
            showGlobalFilter: true,
            showColumnFilters: !isMobile,
            columnVisibility: isMobile
                ? {
                    id_ordem_compra: true,
                    status: true,
                    nivel_prioridade: false,
                    usuario: false,
                    descricao: false,
                    valor_total: false,
                    financeiro: false,
                    data_criacao: false,
                    solicitantes: false,
                    compras: false,
                    data_hora_maxima_conclusao: false,
                }
                : { nivel_prioridade: false },
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: `${tableHeight}px`,
                overflowX: 'auto',
                overflowY: 'auto',
                backgroundColor: '#f9f9f9',
            },
        },
        enableStickyHeader: !isMobile,
        muiPaginationProps: {
            rowsPerPageOptions: [100, 200, 400],
            variant: 'outlined',
        },
        muiTableHeadCellProps: {
            sx: {
                padding: '4px',
                fontSize: '0.75rem',
                lineHeight: 1,
                height: '28px',
                color: '#222',
                display: isMobile ? 'none' : 'table-cell',
            },
        },
        muiTableBodyCellProps: {
            sx: {
                padding: '4px',
                fontSize: '0.75rem',
                lineHeight: 1.2,
                color: '#222',
            },
        },
        muiTableBodyRowProps: { sx: { height: '14px' } },
        enableFullScreenToggle: !isMobile,
        renderRowActions: ({ row }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '1rem',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Tooltip title="Gerenciar">
                    <IconButton
                        color="primary"
                        onClick={() => handleClickEdicao(row.original)}
                    >
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Link" arrow>
                    <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => handleCopyLink(row.original.id_ordem_compra)}

                    >
                        <LinkIcon fontSize="small" />
                    </IconButton>
                </Tooltip>

                {row.original.status === 2 && (
                    <Tooltip title="Reforçar Autorização" arrow>
                        <IconButton
                            size="small"
                            color="success" // usa o verde padrão do tema
                            onClick={() => handleClickReforcarAutorizacao(row.original.id_ordem_compra)}
                        >
                            <VerifiedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        ),
        renderDetailPanel: ({ row }) =>
            isMobile && (
                <Grid container spacing={2} sx={{ p: 2 }}>
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ p: 2, bgcolor: '#fafafa' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Informações Gerais
                            </Typography>
                            <Divider sx={{ mb: 1 }} />
                            <Typography><b>Criador:</b> {row.original.usuario?.nome_amigavel}</Typography>
                            <Typography><b>Solicitantes:</b> {row.original.solicitantes?.map(s => s.nome_amigavel).join(', ') || '-'}</Typography>
                            <Typography><b>Descrição:</b> {row.original.descricao}</Typography>
                            <Typography>
                                <b>Valor Total:</b>{' '}
                                {row.original.valor_total?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '-'}
                            </Typography>
                            <Typography><b>Data Criação:</b> {formatDate(row.original.data_criacao)}</Typography>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ p: 2, bgcolor: '#fdfdfd' }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                                Assinaturas / Autorizações
                            </Typography>
                            <Divider sx={{ mb: 1 }} />

                            {row.original.autorizacoes && row.original.autorizacoes.length > 0 ? (
                                <List dense>
                                    {row.original.autorizacoes.map((aut, idx) => {
                                        let icon = <EditNoteIcon sx={{ color: 'gray' }} />;
                                        let color = 'gray';

                                        if (aut.autorizado === 1) {
                                            icon = <CheckCircleIcon sx={{ color: 'green' }} />;
                                            color = 'green';
                                        } else if (aut.autorizado === 0) {
                                            icon = <HourglassTopIcon sx={{ color: 'orange' }} />;
                                            color = 'black';
                                        } else if (aut.autorizado === 9) {
                                            icon = <CancelIcon sx={{ color: 'red' }} />;
                                            color = 'red';
                                        }

                                        return (
                                            <ListItem key={idx} sx={{ py: 0.5 }}>
                                                <ListItemIcon>{icon}</ListItemIcon>
                                                <ListItemText
                                                    primary={<span style={{ color }}>{`Status: ${aut.status}`}</span>}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            ) : (
                                <Typography variant="body2" color="text.secondary">
                                    Nenhuma autorização encontrada
                                </Typography>
                            )}
                        </Card>
                    </Grid>

                    {row.original.autorizacoes?.some(
                        (aut) =>
                            parseInt(aut.id_usuario, 10) === parseInt(Cookies.get('id_usuario'), 10) &&
                            parseInt(aut.autorizado, 10) === 0
                    ) && row.original.status === 2 && (
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-end"
                                alignItems="flex-end"
                                item
                                xs={6}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={(e) => handleOpenAutorizar(row.original.id_ordem_compra)}
                                >
                                    Autorizar
                                </Button>
                            </Grid>
                        )}
                </Grid>
            ),
    });





    useEffect(() => {
        if (!objetos || objetos.length === 0) return;

        const visiveis = table.getRowModel().rows.map(r => r.original);

        let abertas = visiveis.filter(d => d.status <= 1).length;
        let aguardando = visiveis.filter(d => d.status === 2).length;
        let solicitante = visiveis.filter(d =>
            d.solicitantes?.some(s => parseInt(s.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10))
        ).length;
        let autorizador = visiveis.filter(d =>
            d.autorizacoes?.some(a => parseInt(a.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10))
        ).length;

        setNumOrdensAbertas(abertas);
        setNumOrdensAguardando(aguardando);
        setNumOrdensSolicitante(solicitante);
        setNumOrdensAutorizador(autorizador);
    }, [table.getState().columnFilters, table.getState().globalFilter, objetos]);


    return (
        <div style={{ minHeight: '100vh', padding: 10, boxSizing: 'border-box' }}>
            <div style={{ paddingTop: 5, overflowX: 'auto' }}>
                {objetos !== null && (
                    <MaterialReactTable
                        table={table}
                        muiTableContainerProps={{
                            sx: {
                                maxWidth: '100%',
                                overflowX: 'auto',
                                padding: 1, // padding interno da tabela
                                boxSizing: 'border-box',
                            },
                        }}
                    />
                )}
            </div>

            <Snackbar
                open={openAviso}
                autoHideDuration={3000}
                onClose={() => setOpenAviso(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setOpenAviso(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Link copiado
                </Alert>
            </Snackbar>
        </div>
    );
}



